module.exports = __webpack_public_path__ + "img/H01060-74.e267a442.jpg";